import { render, staticRenderFns } from "./IranUploadPop.vue?vue&type=template&id=2bfd53c8"
import script from "./IranUploadPop.vue?vue&type=script&lang=js"
export * from "./IranUploadPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2bfd53c8')) {
      api.createRecord('2bfd53c8', component.options)
    } else {
      api.reload('2bfd53c8', component.options)
    }
    module.hot.accept("./IranUploadPop.vue?vue&type=template&id=2bfd53c8", function () {
      api.rerender('2bfd53c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/trans/popup/IranUploadPop.vue"
export default component.exports